export default __webpack_public_path__ + "static/media/ig_icon.b2465d99.svg";